import { processInclude } from 'util/common';

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./storeLocator/storeLocator'));

    if (sessionStorage.getItem("selectionMenu")) {
        let inputValue = sessionStorage.getItem("inputValue");
        let selectionMenu = sessionStorage.getItem("selectionMenu");
        selectionMenu=JSON.parse(selectionMenu);
        sessionStorage.removeItem("inputValue");
        sessionStorage.removeItem("selectionMenu");

        $('#store-postal-code').val(inputValue);
        $('body').trigger('woosmap:chooseOptionFindYourStore', selectionMenu); 
    }    
});
